// MIT License. See license.txt

if (platia_tech.require) {
	platia_tech.require("file_uploader.bundle.js");
} else {
	platia_tech.ready(function () {
		platia_tech.require("file_uploader.bundle.js");
	});
}
